const BUCKET_URL = process.env.REACT_APP_BUCKET_URL

export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

// Monta a URL pública de um arquivo do bucket de forma robusta:
// - URL absoluta (http/https): usada como está (algumas APIs já retornam a URL completa)
// - Normaliza barras invertidas (\) e barras iniciais (/) de registros legados
// - Adiciona o prefixo 'fotos/' apenas quando o caminho não o contém
// - Quando informado id_medium, adiciona o parâmetro de versão registrado via bumpFotoVersion
//   (cache-busting: o backend grava a foto sempre com o mesmo nome de arquivo e,
//   sem a versão, o navegador exibe a imagem anterior cacheada)
export const bucketUrl = (fileName: string, id_medium?: number) => {
  if (!fileName) return ''

  let url: string
  if (/^https?:\/\//i.test(fileName)) {
    url = fileName
  } else {
    const path = fileName.replace(/\\/g, '/').replace(/^\/+/, '')
    url = `${BUCKET_URL}/${path.includes('fotos/') ? path : 'fotos/' + path}`
  }

  const version = id_medium ? sessionStorage.getItem(fotoVersionKey(id_medium)) : null
  return version ? `${url}${url.includes('?') ? '&' : '?'}v=${version}` : url
}

const fotoVersionKey = (id_medium: number) => `foto-version-${id_medium}`

// Registra uma nova versão para a foto do médium; chamar após upload/remoção
// para que as próximas renderizações via bucketUrl furem o cache do navegador
export const bumpFotoVersion = (id_medium: number) => {
  sessionStorage.setItem(fotoVersionKey(id_medium), `${Date.now()}`)
}
